import TrackingRepository from '@/api/repositories/TrackingRepository';
import MagazineRepository from '@/api/repositories/MagazineRepository';
import ApplicationRepository from '@/api/repositories/ApplicationRepository';
import AuthRepository from '@/api/repositories/AuthRepository';

const repositories: any = {
    auth: { Repository: AuthRepository, instance: null },
    application: { Repository: ApplicationRepository, instance: null },
    magazine: { Repository: MagazineRepository, instance: null },
    tracking: { Repository: TrackingRepository, instance: null }
};
/**
 *  Factory to create repositories. All created repositories are singleton instances.
 */
export const RepositoryFactory = {
    get: (name: string) => {
        if (repositories[name].instance) {
            return repositories[name].instance;
        } else {
            return new repositories[name].Repository();
        }
    }
};
